import script from "./PriceListActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceListActions.vue?vue&type=script&setup=true&lang=ts"

import "./PriceListActions.vue?vue&type=style&index=0&id=2d79323a&lang=scss"

const __exports__ = script;

export default __exports__